import styled, { device, themeGet } from "@theme/utils";
export const Form = styled.form`
    margin-top: 30px;
`;
export const Input = styled.input`
    width: 100%;
    background-color: #ffffff;
    padding: 1px 20px;
    color: #000000;
    line-height: 47px;
    border: none;
    border-radius: 10px;
    margin-bottom: 25px;
    border: 1px solid #ddd;
    height: 50px;
    font-weight: 500;
`;
export const RememberForgetWrap = styled.div`
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
`;
export const RememberWrap = styled.div`
    display: flex;
    align-items: center;
`;
export const CheckboxInput = styled.input`
    &[type="checkbox"] {
        position: relative;
        background: 0 0;
        border-width: 0;
        -webkit-box-shadow: none;
        box-shadow: none;
        margin: 0 10px 0 3px;
        cursor: pointer;
        height: 16px;
        width: 16px;
    }
`;
export const DescCheck = styled.p`
    margin-bottom: 0;
`;
export const ButtonBox = styled.div``;
export const MemberRegister = styled.div`
    margin-top: 40px;
`;
export const PageLinkDec = styled.p``;
